<div class="recomendacoes-historicos width-100 height-100" ng-if="recWrap.open">
  <uib-tabset active="recWrap.activeTab" class="tabset">
    <uib-tab heading="Pulverizações" index="'recomendacao'" select="recWrap.activate('pulverizacoes')" disable="recWrap.disabled.recomendacao || disableInHistory()">
      <div ng-controller="HistoricoRecomendacoesCtrl">
        <div class="container-header">
          <div class="pull-right text-muted">
            <a ng-click="newRecommendation()" ng-if="$root.permissions.recomendacao.canManage">
              <i class="icon-newrecommendation" aria-hidden="true"></i> Nova Recomendação
            </a>
          </div>
          <div class="title text-center">
            <h2>
              <strong>PULVERIZAÇÕES</strong>
            </h2>
          </div>
          <!-- Filtros -->
          <div class="btn-group" uib-dropdown dropdown-append-to-body="true" uib-dropdown-toggle>
            <button type="button" class="btn" ng-disabled="disableInHistory()">
              {{(recommendationFilters.recomendante.nome_completo || 'Recomendante') | capitalize | characters:10}} <span class="caret"></span>
            </button>
            <ul class="dropdown-menu-right" uib-dropdown-menu role="menu" ng-hide="disableInHistory()">
              <li role="menuitem" ng-show="recommendationFilters.recomendante">
                <a ng-click="setFilterAttribute({ recomendante: null }, $event)" href="#">Todos</a>
              </li>
              <li role="menuitem" ng-repeat="recomendante in (usuarios || recomendantes) track by recomendante.id">
                <a ng-click="setFilterAttribute({ recomendante }, $event)" href="#">{{recomendante.nome_completo | capitalize}}</a>
              </li>
            </ul>
          </div>

          <div class="btn-group" uib-dropdown dropdown-append-to-body="true" uib-dropdown-toggle>
            <button type="button" class="btn" ng-disabled="disableInHistory()">
              {{(recommendationFilters.status.descricao || 'Status') | humanize | characters:10}} <span class="caret"></span>
            </button>
            <ul class="dropdown-menu-right" uib-dropdown-menu role="menu" ng-hide="disableInHistory()">
              <li role="menuitem" ng-show="recommendationFilters.status">
                <a ng-click="setFilterAttribute({ status: null }, $event)" href="#">Todos</a>
              </li>
              <li role="menuitem" ng-repeat="recommendationStatus in status track by recommendationStatus.id">
                <a ng-click="setFilterAttribute({ status: recommendationStatus }, $event)" href="#">{{::recommendationStatus.label}}</a>
              </li>
            </ul>
          </div>

          <div class="btn-group" uib-dropdown dropdown-append-to-body="true" uib-dropdown-toggle>
            <button type="button" class="btn" ng-disabled="disableInHistory()">
              {{recommendationFilters.atividade.descricao || 'Atividade' | capitalize | characters:15}} <span class="caret"></span>
            </button>
            <ul class="dropdown-menu-right" uib-dropdown-menu ng-hide="disableInHistory()">
              <li ng-show="recommendationFilters.atividade">
                <a ng-click="setFilterAttribute({ atividade: null }, $event)">Todas</a>
              </li>
              <li ng-repeat="atividade in atividades track by $index">
                <a ng-click="setFilterAttribute({ atividade }, $event)">{{atividade.descricao | capitalize}}</a>
              </li>
            </ul>
          </div>

          <div class="btn-group" uib-dropdown dropdown-append-to-body="true" uib-dropdown-toggle>
            <button type="button" class="btn" ng-disabled="disableInHistory()">
              {{(recommendationFilters.gleba.descricao || 'Talhão') | humanize | characters:10}} <span class="caret"></span>
            </button>
            <ul class="dropdown-menu-right" uib-dropdown-menu role="menu" ng-hide="disableInHistory()">
              <li role="menuitem" ng-show="recommendationFilters.gleba">
                <a ng-click="setFilterAttribute({ gleba: null }, $event)" href="#" id="select-gleba">Todas</a>
              </li>
              <li role="menuitem" ng-repeat="gleba in (glebas || data.glebas) track by gleba.id">
                <a ng-click="setFilterAttribute({ gleba }, $event)" href="#" id="select-gleba">{{gleba.descricao}}</a>
              </li>
            </ul>
          </div>

          <div class="btn-group" uib-dropdown dropdown-append-to-body="true" uib-dropdown-toggle>
            <button type="button" class="btn" ng-disabled="disableInHistory()">
              {{period.periodo || 'Período'}} <span class="caret"></span>
            </button>
            <ul class="dropdown-menu-right" uib-dropdown-menu role="menu" ng-hide="disableInHistory()">
              <li role="menuitem" ng-repeat="periodo in filtroPeriodo">
                <a ng-click="setPeriodo(periodo, $event)" href="#">{{::periodo.descricao | capitalize}}</a>
              </li>
              <li role="menuitem">
                <a ng-click="openPeriodsFilter($event)" href="#">Customizado</a>
              </li>
            </ul>
          </div>

          <div class="btn-group" uib-dropdown dropdown-append-to-body="true" uib-dropdown-toggle>
            <button type="button" class="btn" ng-disabled="disableInHistory()" >
              {{recommendationFilters.grupoInsumo.descricao || 'Grupo de Insumo' | capitalize | characters:15}} <span class="caret"></span>
            </button>
            <ul class="dropdown-menu-right" uib-dropdown-menu role="menu" ng-hide="disableInHistory()">
              <li role="menuitem" ng-show="recommendationFilters.grupoInsumo">
                <a ng-click="setFilterAttribute({ grupoInsumo: null }, $event)" href="#">Todos</a>
              </li>
              <li role="menuitem" ng-repeat="grupoInsumo in gruposInsumos track by $index">
                <a ng-click="setFilterAttribute({ grupoInsumo }, $event)" href="#">{{grupoInsumo.descricao | capitalize}}</a>
              </li>
            </ul>
          </div>

          <div class="btn-group" uib-dropdown dropdown-append-to-body="true" uib-dropdown-toggle>
            <button type="button" class="btn">
              <i class="fa fa-print"></i>
            </button>

            <ul class="dropdown-menu-right" uib-dropdown-menu role="menu">
              <li role="menuitem">
                <a ng-click="reportDemandaUso($event)" href="#">Demanda de uso de defensivos</a>
              </li>
            </ul>
          </div>
          <!-- Fim Filtros -->
        </div>
        <div ng-if="getSelectedRecommendations().length" class="text-center margin">
          <p><b>{{getSelectedRecommendations().length}}</b> selecionada(s). Qual ação deseja executar em TODAS?</p>
          <div class="btn-group">
            <button type="button" class="btn btn-white btn-sm" ng-click="bulkPrint()">
              <i class="fa fa-print"></i> Imprimir
            </button>
            <button type="button" class="btn btn-white btn-sm" ng-click="bulkConclude()" ng-if="$root.permissions.recomendacao.canManage">
              <i class="fa fa-check"></i> Encerrar recomendação
            </button>
          </div>
        </div>
        <div class="container-body width-100 recomendacoes-body" ng-include="'views/painel_propriedade/_accordion_recomendacao.html'"></div>
      </div>
    </uib-tab>
    <uib-tab heading="Correção de solo" index="'correcaoSolo'" select="recWrap.activate('correcao')" disable="recWrap.disabled.recomendacaoCorrecaoSolo || disableInHistory()">
      <div ng-controller="HistoricoRecomendacoesCorrecaoSoloCtrl">
        <div class="container-header">
          <div class="pull-right text-muted">
            <a ng-click="newRecommendation()" ng-if="$root.permissions.recomendacaoCorrecaoSolo.canManage">
              <i class="icon-newrecommendation" aria-hidden="true"></i> Nova Recomendação
            </a>
          </div>
          <div class="title text-center">
            <h2>
              <strong>CORREÇÃO DE SOLO</strong>
            </h2>
          </div>
          <!-- Filtros -->
          <div class="btn-group" uib-dropdown dropdown-append-to-body="true" uib-dropdown-toggle>
            <button type="button" class="btn" ng-disabled="disableInHistory()">
              {{(recommendationFilters.recomendante.nome_completo || 'Recomendante') | capitalize | characters:10}} <span class="caret"></span>
            </button>
            <ul class="dropdown-menu-right" uib-dropdown-menu role="menu" ng-hide="disableInHistory()">
              <li role="menuitem" ng-show="recommendationFilters.recomendante">
                <a ng-click="setFilterAttribute({ recomendante: null }, $event)" href="#">Todos</a>
              </li>
              <li role="menuitem" ng-repeat="recomendante in (usuarios || recomendantes) track by recomendante.id">
                <a ng-click="setFilterAttribute({ recomendante }, $event)" href="#">{{recomendante.nome_completo | capitalize}}</a>
              </li>
            </ul>
          </div>

          <div class="btn-group" uib-dropdown dropdown-append-to-body="true" uib-dropdown-toggle>
            <button type="button" class="btn" ng-disabled="disableInHistory()">
              {{(recommendationFilters.status.descricao || 'Status') | humanize | characters:10}} <span class="caret"></span>
            </button>
            <ul class="dropdown-menu-right" uib-dropdown-menu role="menu" ng-hide="disableInHistory()">
              <li role="menuitem" ng-show="recommendationFilters.status">
                <a ng-click="setFilterAttribute({ status: null }, $event)" href="#">Todos</a>
              </li>
              <li role="menuitem" ng-repeat="recommendationStatus in status track by recommendationStatus.id">
                <a ng-click="setFilterAttribute({ status: recommendationStatus }, $event)" href="#">{{::recommendationStatus.label}}</a>
              </li>
            </ul>
          </div>

          <div class="btn-group" uib-dropdown dropdown-append-to-body="true" uib-dropdown-toggle>
            <button type="button" class="btn" ng-disabled="disableInHistory()">
              {{(recommendationFilters.gleba.descricao || 'Talhão') | humanize | characters:10}} <span class="caret"></span>
            </button>
            <ul class="dropdown-menu-right" uib-dropdown-menu role="menu" ng-hide="disableInHistory()">
              <li role="menuitem" ng-show="recommendationFilters.gleba">
                <a ng-click="setFilterAttribute({ gleba: null }, $event)" href="#" id="select-gleba">Todas</a>
              </li>
              <li role="menuitem" ng-repeat="gleba in $root.currentPropriedade.glebas track by gleba.id">
                <a ng-click="setFilterAttribute({ gleba }, $event)" href="#" id="select-gleba">{{gleba.descricao}}</a>
              </li>
            </ul>
          </div>

          <div class="btn-group" uib-dropdown dropdown-append-to-body="true" uib-dropdown-toggle>
            <button type="button" class="btn" ng-disabled="disableInHistory()">
              {{period.periodo || 'Período'}} <span class="caret"></span>
            </button>
            <ul class="dropdown-menu-right" uib-dropdown-menu role="menu" ng-hide="disableInHistory()">
              <li role="menuitem" ng-repeat="periodo in filtroPeriodo">
                <a ng-click="setPeriodo(periodo, $event)" href="#">{{::periodo.descricao | capitalize}}</a>
              </li>
              <li role="menuitem">
                <a ng-click="openPeriodsFilter($event)" href="#">Customizado</a>
              </li>
            </ul>
          </div>
          <div class="btn-group" uib-dropdown dropdown-append-to-body="true" uib-dropdown-toggle>
            <button type="button" class="btn">
              <i class="fa fa-print"></i>
            </button>

            <ul class="dropdown-menu-right" uib-dropdown-menu role="menu">
              <li role="menuitem">
                <a ng-click="reportDemandaUso($event)" href="#">Demanda de uso de defensivos</a>
              </li>
            </ul>
          </div>
          <!-- Fim Filtros -->
        </div>

        <div class="container-body width-100 recomendacoes-body" ng-include="'views/painel_propriedade/_accordion_correcao_solo.html'"></div>
      </div>
    </uib-tab>
    <uib-tab heading="Adubação" index="'adubacao'" select="recWrap.activate('adubacao')" disable="recWrap.disabled.recomendacaoAdubacaoCobertura || disableInHistory()">
      <div ng-controller="HistoricoRecomendacoesAdubacaoCtrl">
        <div class="container-header">
          <div class="pull-right text-muted">
            <a ng-click="newRecommendation()" ng-if="$root.permissions.recomendacaoAdubacaoCobertura.canManage">
              <i class="icon-newrecommendation" aria-hidden="true"></i> Nova Recomendação
            </a>
          </div>
          <div class="title text-center">
            <h2>
              <strong>ADUBAÇÃO</strong>
            </h2>
          </div>
          <!-- Filtros -->
          <div class="btn-group" uib-dropdown dropdown-append-to-body="true" uib-dropdown-toggle>
            <button type="button" class="btn" ng-disabled="disableInHistory()">
              {{(recommendationFilters.recomendante.nome_completo || 'Recomendante') | capitalize | characters:10}} <span class="caret"></span>
            </button>
            <ul class="dropdown-menu-right" uib-dropdown-menu role="menu" ng-hide="disableInHistory()">
              <li role="menuitem" ng-show="recommendationFilters.recomendante">
                <a ng-click="setFilterAttribute({ recomendante: null }, $event)" href="#">Todos</a>
              </li>
              <li role="menuitem" ng-repeat="recomendante in (usuarios || recomendantes) track by recomendante.id">
                <a ng-click="setFilterAttribute({ recomendante }, $event)" href="#">{{recomendante.nome_completo | capitalize}}</a>
              </li>
            </ul>
          </div>

          <div class="btn-group" uib-dropdown dropdown-append-to-body="true" uib-dropdown-toggle>
            <button type="button" class="btn" ng-disabled="disableInHistory()">
              {{(recommendationFilters.status.descricao || 'Status') | humanize | characters:10}} <span class="caret"></span>
            </button>
            <ul class="dropdown-menu-right" uib-dropdown-menu role="menu" ng-hide="disableInHistory()">
              <li role="menuitem" ng-show="recommendationFilters.status">
                <a ng-click="setFilterAttribute({ status: null }, $event)" href="#">Todos</a>
              </li>
              <li role="menuitem" ng-repeat="recommendationStatus in status track by recommendationStatus.id">
                <a ng-click="setFilterAttribute({ status: recommendationStatus }, $event)" href="#">{{::recommendationStatus.label}}</a>
              </li>
            </ul>
          </div>

          <div class="btn-group" uib-dropdown dropdown-append-to-body="true" uib-dropdown-toggle>
            <button type="button" class="btn" ng-disabled="disableInHistory()">
              {{(recommendationFilters.atividade.descricao || 'Atividade') | capitalize | characters:10}} <span class="caret"></span>
            </button>
            <ul class="dropdown-menu-right" uib-dropdown-menu role="menu" ng-hide="disableInHistory()">
              <li role="menuitem" ng-show="recommendationFilters.atividade">
                <a ng-click="setFilterAttribute({ atividade: null }, $event)" href="#">Todos</a>
              </li>
              <li role="menuitem" ng-repeat="recommendationAtividade in atividades track by recommendationAtividade.id">
                <a ng-click="setFilterAttribute({ atividade: recommendationAtividade }, $event)" href="#">{{::recommendationAtividade.descricao | capitalize}}</a>
              </li>
            </ul>
          </div>

          <div class="btn-group" uib-dropdown dropdown-append-to-body="true" uib-dropdown-toggle>
            <button type="button" class="btn" ng-disabled="disableInHistory()">
              {{(recommendationFilters.gleba.descricao || 'Talhão') | humanize | characters:10}} <span class="caret"></span>
            </button>
            <ul class="dropdown-menu-right" uib-dropdown-menu role="menu" ng-hide="disableInHistory()">
              <li role="menuitem" ng-show="recommendationFilters.gleba">
                <a ng-click="setFilterAttribute({ gleba: null }, $event)" href="#" id="select-gleba">Todas</a>
              </li>
              <li role="menuitem" ng-repeat="gleba in (glebas || data.glebas) track by $index">
                <a ng-click="setFilterAttribute({ gleba }, $event)" href="#" id="select-gleba">{{gleba.descricao}}</a>
              </li>
            </ul>
          </div>

          <div class="btn-group" uib-dropdown dropdown-append-to-body="true" uib-dropdown-toggle>
            <button type="button" class="btn" ng-disabled="disableInHistory()">
              {{period.periodo || 'Período'}} <span class="caret"></span>
            </button>
            <ul class="dropdown-menu-right" uib-dropdown-menu role="menu" ng-hide="disableInHistory()">
              <li role="menuitem" ng-repeat="periodo in filtroPeriodo">
                <a ng-click="setPeriodo(periodo, $event)" href="#">{{::periodo.descricao | capitalize}}</a>
              </li>
              <li role="menuitem">
                <a ng-click="openPeriodsFilter($event)" href="#">Customizado</a>
              </li>
            </ul>
          </div>
          <div class="btn-group" uib-dropdown dropdown-append-to-body="true" uib-dropdown-toggle>
            <button type="button" class="btn">
              <i class="fa fa-print"></i>
            </button>

            <ul class="dropdown-menu-right" uib-dropdown-menu role="menu">
              <li role="menuitem">
                <a ng-click="reportDemandaUso($event)" href="#">Demanda de uso de defensivos</a>
              </li>
            </ul>
          </div>
          <!-- Fim Filtros -->
        </div>

        <div class="container-body width-100 recomendacoes-body" ng-include="'views/painel_propriedade/_accordion_adubacao.html'"></div>
      </div>
    </uib-tab>
  </ui-tabset>
</div>

<script type="text/ng-template" id="modal-report-demanda-uso.html">
  <div class="modal-header">
    <h3 class="modal-title" id="modal-title">Demanda de uso de Insumos</h3>
  </div>

  <div class="modal-body" id="modal-body">
    <div class="form-group">
      <ui-select class="modal-select" multiple ng-model="params.propriedades" theme="bootstrap" id="propriedades" name="propriedades">
        <ui-select-match allow-clear="true" placeholder="Propriedade(s)">{{$item.descricao | capitalize}}</ui-select-match>
        <ui-select-choices repeat="propriedade in allPropriedades | orderBy: 'descricao' | filter: $select.search">
          <span  class="form-group" ng-bind-html="propriedade.descricao | capitalize | highlight: $select.search"></span>
        </ui-select-choices>
      </ui-select>

      <label class="control-label">Período</label>
      <input date-range-picker class="form-control date-picker" type="text" ng-model="params.period" options="opts" readonly />
    </div>

    <div class="only-print" id="demanda-uso-insumos" ng-include="'views/demandausoinsumos.html'"></div>
  </div>
  <div class="modal-footer">
    <button class="btn btn-primary" type="button" ng-disabled="loading" ng-click="get()">
      OK
      <span ng-if="loading"><i class="fa fa-spinner fa-spin"></i></span>
    </button>
    <button class="btn btn-warning" type="button" ng-disabled="loading" ng-click="close()">Cancelar</button>
    <button ng-print print-element-id="demanda-uso-insumos" class="hide" id="btn-print"></button>
  </div>
</script>
